import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, coerceBoolean } from '@tyler-components-web/core';
import { tylIconCancel } from '@tylertech/tyler-icons/standard';
import { BANNER_CONSTANTS } from './banner-constants';
import { BannerFoundation } from './banner-foundation';
import { BannerAdapter } from './banner-adapter';
import { IconButtonComponent } from '../icon-button';
import { TooltipComponent } from '../tooltip';
import { IconComponent, TylerIconRegistry } from '../icon';
var template = require('./banner.html');
var styles = require('./banner.css');
/**
 * The custom element class behind the `<tcw-banner>` element.
 */
var BannerComponent = /** @class */ (function (_super) {
    __extends(BannerComponent, _super);
    function BannerComponent() {
        var _this = _super.call(this) || this;
        TylerIconRegistry.define(tylIconCancel);
        attachShadowTemplate(_this, BANNER_CONSTANTS.elementName, template, styles);
        _this._foundation = new BannerFoundation(new BannerAdapter(_this));
        return _this;
    }
    Object.defineProperty(BannerComponent, "observedAttributes", {
        get: function () {
            return [
                BANNER_CONSTANTS.attributes.DISMISSED,
                BANNER_CONSTANTS.attributes.CAN_DISMISS
            ];
        },
        enumerable: true,
        configurable: true
    });
    BannerComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'dismissed');
        upgradeProperty(this, 'canDismiss');
    };
    BannerComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case BANNER_CONSTANTS.attributes.DISMISSED:
                this.dismissed = coerceBoolean(newValue);
                break;
            case BANNER_CONSTANTS.attributes.CAN_DISMISS:
                this.canDismiss = coerceBoolean(newValue);
                break;
        }
    };
    BannerComponent.prototype.connectedCallback = function () {
        this._foundation.connect();
    };
    BannerComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    Object.defineProperty(BannerComponent.prototype, "dismissed", {
        get: function () {
            return this._foundation.dismissed;
        },
        set: function (val) {
            this._foundation.dismissed = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerComponent.prototype, "canDismiss", {
        get: function () {
            return this._foundation.canDismiss;
        },
        set: function (val) {
            this._foundation.canDismiss = val;
        },
        enumerable: true,
        configurable: true
    });
    BannerComponent = __decorate([
        CustomElement({
            name: BANNER_CONSTANTS.elementName,
            dependencies: [
                IconButtonComponent,
                IconComponent,
                TooltipComponent
            ]
        })
    ], BannerComponent);
    return BannerComponent;
}(HTMLElement));
export { BannerComponent };
